import * as types from '@/store/types.js'
import User from '@/model/User'
import {removeResource, activeResource} from '@/store/helpers'

const state = {
  users: {
    pagination: {},
    data: {}
  },
  activeUser: {},
  isLoading: false
}

// GETTERS
const getters = {
  [types.ALL_USERS]: state => state.users,
  [types.ACTIVE_USER]: state => state.activeUser,
  [types.IS_LOADING_USERS]: state => state.isLoading
}

// ACTIONS
const actions = {
  [types.GET_ALL_USERS]: ({ commit }, value) => {
    commit(types.GET_ALL_USERS, value)
  },
  [types.ADD_USER]: ({ commit }, value) => {
    commit(types.ADD_USER, value)
  },
  [types.REMOVE_USER]: ({ commit }, value) => {
    commit(types.REMOVE_USER, value)
  },
  [types.ACTIVE_USER]: ({ commit }) => {
    commit(types.ACTIVE_USER)
  },
  [types.UPDATE_USER_URL]: ({ commit }, value) => {
    commit(types.UPDATE_USER_URL, value)
  },
  [types.IS_LOADING_USERS]: ({ commit }, value) => {
    commit(types.IS_LOADING_USERS, value)
  }
}

// MUTATIONS
const mutations = {
  [types.GET_ALL_USERS] (state, value) {
    state.users = value
  },
  [types.ADD_USER]: (state, value) => {
    state.users.data.unshift(value)
  },
  [types.REMOVE_USER]: (state, value) => {
    removeResource(User, value, state.users, 'users.index')
  },
  [types.ACTIVE_USER]: (state, value) => {
    state.activeUser = activeResource(state.users.data)
  },
  [types.UPDATE_USER_URL]: (state, value) => {
    state.activeUser.url = value
  },
  [types.IS_LOADING_USERS]: (state, value) => {
    state.isLoading = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/User.js